import { dispatch } from "./api.service";
import jwtService from "./jwt.service";

const base = "/user";

export const register = (data) => dispatch(data, `${base}/register`);
export const login = (data) => dispatch(data, `${base}/login`);
// export const resetPassword = (data) =>
//   dispatch(data, `${base}/password/forgot`);
export const confirmEmail = (data) =>
  dispatch(data, `${base}/email/confirmation`);
export const resendEmail = (data) => dispatch(data, `${base}/email/resend`);
export const logout = () => {
  jwtService.destroyItem("token");
  jwtService.destroyItem("user");
};
